import {CompositionPhotoCrop, CompositionPhotoLayer} from '@dms/api/shared';

type Size = {width: number; height: number};
type Rect = {left: number; top: number; width: number; height: number};

const FULL_PHOTO: CompositionPhotoCrop = {x: 0, y: 0, width: 1, height: 1};

/**
 * Places a photo in a layer box the way the BE renderer does: it crops the photo first, then
 * scales the cropped part to the box (`contain` fits it inside, `cover` fills the box) with its
 * aspect ratio kept, and centers it. `region` is the visible cropped part relative to the box
 * (it clips the photo); `photo` is the whole photo relative to the region.
 */
export const getCroppedPhotoStyle = (
  crop: CompositionPhotoCrop | undefined,
  fit: CompositionPhotoLayer['fit'],
  box: Size,
  photo: Size
): {region: Rect; photo: Rect} => {
  const {x, y, width, height} = crop ?? FULL_PHOTO;
  const sourceWidth = width * photo.width;
  const sourceHeight = height * photo.height;
  const scaleToBox = fit === 'cover' ? Math.max : Math.min;
  const ratio = scaleToBox(box.width / sourceWidth, box.height / sourceHeight);
  const regionWidth = sourceWidth * ratio;
  const regionHeight = sourceHeight * ratio;

  return {
    region: {
      left: (box.width - regionWidth) / 2,
      top: (box.height - regionHeight) / 2,
      width: regionWidth,
      height: regionHeight,
    },
    photo: {
      left: 0 - x * photo.width * ratio,
      top: 0 - y * photo.height * ratio,
      width: photo.width * ratio,
      height: photo.height * ratio,
    },
  };
};
